import { render, staticRenderFns } from "./LessonHeader.vue?vue&type=template&id=5aa4bc2c&scoped=true&"
import script from "./LessonHeader.vue?vue&type=script&lang=js&"
export * from "./LessonHeader.vue?vue&type=script&lang=js&"
import style0 from "./LessonHeader.vue?vue&type=style&index=0&id=5aa4bc2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4bc2c",
  null
  
)

export default component.exports